// eslint-disable-next-line import/no-unresolved
import React from 'react';
// eslint-disable-next-line import/no-unresolved
import styled from 'styled-components';

import Styles from './OptionsInput.styles.js';
import TicketInfo from '../../compound/TicketInfo';
import { saveQuickData, setParkingStatus, saveQuickShutleData } from '../../../helpers/CartManager';

const Wrapper = styled.div`${Styles.wrapper}`; // prettier-ignore

/**
 * OptionsInput component
 * @param {string} className - modifier class
 * @param {string} defaultValue - default valu for select box
 * @param {string} name - input's name
 * @param {Array} options - input's options
 * @param {Array} optionsO - input's options
 * @param {string} color - optional color
 * @param {bool} isSorting - true if its a sorting select
 * @returns {?JSX}
 */
const QuickSelector = (props) => {

  const continueShopping = () => {
    const {
      isFamily,
      activeTicketType,
      ticketNumber,
      activeTravelType,
      flightDate,
      returnDate,
      locale,
      origin,
      destination,
      travelPurpose,
      shuttleDestination,
      shuttleOrigin,
      shuttleStartDate,
      shuttleEndDate,
      shuttlePassengers,
      shuttleTravel,
      shuttleTravelType,
      shuttleTravelHandler,
      startDate,
      endDate,
      startTime,
      endTime,
      lot,
      selectorItem,
      company,
      getLots,
      getShuttleRoutes
    } = props;

    saveQuickData({
      ticketType: activeTicketType,
      activeTicketType,
      isFamily,
      ticketNumber,
      activeTravelType,
      travelType: activeTravelType,
      flightDate,
      returnDate,
      origin,
      destination,
      activeTravelPurpose: travelPurpose,
      travelPurpose,
      shuttleDestination,
      shuttleOrigin,
      shuttleTravel,
      shuttleTravelType,
      startDate,
      startTime,
      endDate,
      endTime,
      lot,
      company,
      shuttleDestination,
      shuttleOrigin,
      shuttleStartDate,
      shuttleEndDate,
      shuttlePassengers,
    });
    if (selectorItem === 'Parking') {
      window.localStorage.setItem('currentFlow', 'Parking');
      getLots();
    }

    if(selectorItem === 'Ticket') {
      window.localStorage.setItem('currentFlow', 'Ticket');
      if([`${process.env.GATSBY_BASE_UNAT_ID}`,`${process.env.GATSBY_BASE_ASSISTED_PASS_ID}`].includes(activeTicketType)){
        window.location.href = `/${locale}/assistPassForm`;
      }else{
        window.location.href = `/${locale}/configTicket`;
      }
    }

    if (selectorItem === 'Shuttle') {
      window.localStorage.setItem('currentFlow', 'Shuttle');
      console.log("Searching Routes");
      getShuttleRoutes()
    }

    if (selectorItem === 'Bundles') {
      window.localStorage.setItem('currentFlow', 'Bundles');
      window.location.href = `/${locale}/configTicket`
    }
    if (selectorItem === 'Wheels') {
      window.localStorage.setItem('currentFlow', 'Wheels');
      window.location.href = `/${locale}/wheels`
    }

  };
  const goToSelectTrip = () => {
    const {locale} = props;
    window.location.href = `/${locale}/shuttleSelectTrip`
  }

  return (
    <Wrapper>
      <TicketInfo {...props} confirmAction={continueShopping} goToSelectTrip={goToSelectTrip} />
    </Wrapper>
  );
};

export default QuickSelector;
